module.exports = "/_next/static/images/payroll-financing-a31206d499c16a504047c4b938a1fdcc.svg";